import React, { FC } from "react";

const SkeletonLarge: FC = () => {
  return (
    <div className="w-[80%] h-[80%] flex justify-center items-center rounded-lg bg-slate-400 animate-pulse text-white">
        Loading...
    </div>
  );
};

export default SkeletonLarge;